module.exports = __webpack_public_path__ + "img/pauli-z-root-33.5ad565f1.svg";